import { render, staticRenderFns } from "./ApplicationsConfiguration.vue?vue&type=template&id=0908b672&scoped=true&"
import script from "./ApplicationsConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ApplicationsConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationsConfiguration.vue?vue&type=style&index=0&id=0908b672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0908b672",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VForm,VIcon,VImg,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0908b672')) {
      api.createRecord('0908b672', component.options)
    } else {
      api.reload('0908b672', component.options)
    }
    module.hot.accept("./ApplicationsConfiguration.vue?vue&type=template&id=0908b672&scoped=true&", function () {
      api.rerender('0908b672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/ApplicationsConfiguration.vue"
export default component.exports